import { BrowserRouter } from 'react-router-dom';
import { loadApp, SiteSettingsProvider } from '@namespace/layout';
import { OnboardingProvider } from '@namespace/onboarding';
import App from './components/App';
import DATE_FORMATS from './constants/dateFormats';

const AppWrapper = ({ initialPageConfig }) => (
  <BrowserRouter>
    <OnboardingProvider>
      <SiteSettingsProvider>
        <App initialPageConfig={initialPageConfig} />
      </SiteSettingsProvider>
    </OnboardingProvider>
  </BrowserRouter>
);

const partnerConfig = {
  DATE_FORMATS
};

loadApp(AppWrapper, partnerConfig);
